import { z } from "zod";

export const InvitationAcceptFormSchema = z.object({
  password: z
    .string().min(8, "パスワードは8文字以上で入力してください")
    .refine(
      (val) => /^[A-Za-z0-9\^$*.\[\]{}()?\-"!@#%&/,><':;|_~`+=]*$/.test(val),
      { message: "パスワードに使えない文字が含まれています" }
    )
    .refine(
      (val) => /[A-Z]/.test(val) && /[a-z]/.test(val) && /[0-9]/.test(val)
        && /[^$*.\[\]{}()?\-"!@#%&\/,><':;|_~`+=]/.test(val),
      {
        message:
          "パスワードには大文字、小文字、数字、特殊文字をそれぞれ1文字以上含める必要があります",
      }
    ),
  confirmPassword: z.string().min(8, "確認用パスワードは8文字以上で入力してください"),
}).refine(
  (data) => data.password === data.confirmPassword,
  {
    message: "パスワードと確認用パスワードが一致しません",
    path: ["confirmPassword"],
  }
);

export type InvitationAcceptFormData = z.infer<typeof InvitationAcceptFormSchema>;
